import styled from "styled-components";
import { forwardRef } from "react";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: var(--mui-palette-background-default);
  overflow: hidden;
  box-sizing: border-box;
`;

export const HeaderContainer = styled.div`
  display: none;
`;

export const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--mui-palette-text-primary);
  margin: 0;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const FrameContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  flex: 1;
  overflow: hidden;
  background-color: var(--mui-palette-background-paper);
  box-shadow: var(--mui-shadows-2);
`;

export const ToolbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--mui-palette-divider);
`;

export const ToolbarLeft = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ToolbarCenter = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

export const ToolbarRight = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;

  /* 버튼 사이 간격 조정 */
  & > div {
    display: flex;
    gap: 0.5rem;
  }
`;

export const InnerContainer = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  /* 테이블 스타일 오버라이드 */
  .MuiPaper-root {
    box-shadow: none;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
  }

  .MuiTable-root {
    border-collapse: separate;
    border-spacing: 0;
  }

  .MuiTableContainer-root {
    flex: 1;
    overflow: auto;
  }

  .MuiTableHead-root {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: var(--mui-palette-background-paper);
  }

  .MuiTableRow-root:hover {
    background-color: var(--mui-palette-action-hover);
  }
`;

export const DimBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  backdrop-filter: blur(3px);
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DimContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;

  p {
    color: var(--mui-palette-common-white);
    font-size: 1.2rem;
    font-weight: 500;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  }
`;

export const ModelSelectArea = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const GraphContainer = styled.div`
  width: 100%;
  margin-top: 10px;
`;
export const GraphContainerInner = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 10px;
  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const ChartWrapper = styled.div`
  width: 5220px;
  height: 400px;
`;

export const InnerContainerWithScroll = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 1rem;
  &::-webkit-scrollbar {
    width: 8px;
    background: #918fb5;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #918fb5;
    border-radius: 4px;
  }
  /* 테이블 스타일 오버라이드 */
  .MuiPaper-root {
    box-shadow: none;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
  }

  .MuiTable-root {
    border-collapse: separate;
    border-spacing: 0;
  }

  .MuiTableContainer-root {
    flex: 1;
    overflow: auto;
  }

  .MuiTableHead-root {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: var(--mui-palette-background-paper);
  }

  .MuiTableRow-root:hover {
    background-color: var(--mui-palette-action-hover);
  }
`;

const ChartScrollContainer = forwardRef((props, ref) => (
  <div ref={ref} className={props.className} onScroll={props.onScroll}>
    {props.children}
  </div>
));
ChartScrollContainer.defaultProps = {
  className: "chart-scroll-container",
};
const StyledChartScrollContainer = styled(ChartScrollContainer)`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;

  /* 스크롤바 스타일링 */
  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
export { StyledChartScrollContainer as ChartScrollContainer };
